import { render, staticRenderFns } from "./ModalLuckysMarket.vue?vue&type=template&id=40f63d59"
import script from "./ModalLuckysMarket.vue?vue&type=script&lang=js"
export * from "./ModalLuckysMarket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports